<template>
	<el-dropdown trigger="click" class="international" @command="handleSetLanguage">
		<div>
			<template v-if="$i18n.locale === 'nl'">
				<div>
					Nederlands
				</div>
			</template>
			<template v-else-if="$i18n.locale === 'en'">
				<div>
					English
				</div>
			</template>
			<template v-else-if="$i18n.locale === 'fr'">
				<div>
					Français
				</div>
			</template>
			<template v-else>
				<svg-icon class-name="international-icon" icon-class="language" />
			</template>
		</div>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item command="nl">Nederlands</el-dropdown-item>
			<el-dropdown-item command="fr">Français</el-dropdown-item>
			<el-dropdown-item command="en">English</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
import Logging from '@/logging';

export default {
	methods: {
		handleSetLanguage(lang) {
			Logging.log('LangSelect.handleSetLanguage');
			Logging.log('LangSelect.handleSetLanguage - lang: ', lang);
			this.$i18n.locale = lang;
			localStorage.setItem('rslt-language', lang);
		}
	}
};
</script>
